import { PropsWithChildren } from "react";

const ComplianceProgramFormStep = ({
  title,
  children,
}: PropsWithChildren<{
  title: string;
}>) => {
  return (
    <div className="border rounded-md bg-gray-25">
      <div className="pt-6 pb-4 px-6 flex items-center justify-between">
        <div className="tf-header-base-dark">{title}</div>
      </div>
      {children}
    </div>
  );
};

export default ComplianceProgramFormStep;
